import React, { useState } from 'react';
import {
    Box,
    Container,
    TextField,
    Button,
    Typography,
    Paper,
    Alert,
    CircularProgress,
    Stack
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

function AdminLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loginError, setLoginError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { login } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoginError('');
        setIsSubmitting(true);

        try {
            await login(email, password);
            // Logowanie zakończone sukcesem, auth-service zaaktualizuje currentUser
        } catch (error) {
            setLoginError('Nieprawidłowy email lub hasło');
            console.error('Błąd logowania:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    mt: { xs: 4, sm: 8 },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        p: { xs: 2, sm: 3 },
                        width: '100%',
                        borderRadius: '0.75rem',
                        backgroundColor: 'rgba(17, 24, 39, 0.95)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(76, 29, 149, 0.2)',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
                    }}
                >
                    <Typography
                        variant="h5"
                        component="h1"
                        align="center"
                        sx={{
                            mb: 3,
                            fontWeight: '700',
                            color: 'white',
                            fontSize: { xs: '1.25rem', sm: '1.5rem' }
                        }}
                    >
                        Panel Admin
                    </Typography>

                    {loginError && (
                        <Alert severity="error" sx={{ mb: 2, borderRadius: '0.5rem' }}>
                            {loginError}
                        </Alert>
                    )}

                    <form onSubmit={handleSubmit}>
                        <Stack spacing={2}>
                            <TextField
                                label="Email"
                                variant="outlined"
                                fullWidth
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                type="email"
                                size="small"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'rgba(76, 29, 149, 0.08)',
                                        '& fieldset': {
                                            borderColor: 'rgba(76, 29, 149, 0.2)',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: 'rgba(76, 29, 149, 0.4)',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: 'rgb(196, 181, 253)',
                                        },
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: 'rgb(196, 181, 253)',
                                    },
                                    '& .MuiInputBase-input': {
                                        color: 'white',
                                    },
                                }}
                            />

                            <TextField
                                label="Hasło"
                                variant="outlined"
                                fullWidth
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                type="password"
                                size="small"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'rgba(76, 29, 149, 0.08)',
                                        '& fieldset': {
                                            borderColor: 'rgba(76, 29, 149, 0.2)',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: 'rgba(76, 29, 149, 0.4)',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: 'rgb(196, 181, 253)',
                                        },
                                    },
                                    '& .MuiInputLabel-root': {
                                        color: 'rgb(196, 181, 253)',
                                    },
                                    '& .MuiInputBase-input': {
                                        color: 'white',
                                    },
                                }}
                            />

                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                size="large"
                                sx={{
                                    mt: 1,
                                    py: 1.25,
                                    backgroundColor: 'rgb(76, 29, 149)',
                                    '&:hover': {
                                        backgroundColor: 'rgb(91, 33, 182)',
                                    },
                                    '&.Mui-disabled': {
                                        backgroundColor: 'rgba(76, 29, 149, 0.3)',
                                        color: 'rgba(255, 255, 255, 0.5)'
                                    },
                                    borderRadius: '0.5rem',
                                    fontWeight: '600'
                                }}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <CircularProgress size={20} color="inherit" />
                                ) : (
                                    'Zaloguj się'
                                )}
                            </Button>
                        </Stack>
                    </form>
                </Paper>
            </Box>
        </Container>
    );
}

export default AdminLogin;